import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const AttachmentSchema = withDefaults({
  type: 'attachment',
  objectExtensions: ['attachment'],
  fields: [
    {
      kind: 'attribute',
      name: 'signedUrl',
    },
    {
      kind: 'attribute',
      name: 'classification',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'tags',
    },
    {
      kind: 'attribute',
      name: 'attachmentDeletedAt',
    },
    {
      kind: 'attribute',
      name: 'filename',
    },
    {
      kind: 'attribute',
      name: 'contentType',
    },
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'assetClassification',
    },
    {
      kind: 'attribute',
      name: 'assetDescription',
    },
    {
      kind: 'belongsTo',
      name: 'digitalAsset',
      type: 'digital-asset',
      options: {
        async: false,
        inverse: null,
        polymorphic: true,
      },
    },
  ],
});

export default AttachmentSchema;
